import type { ResultOf } from '@graphql-typed-document-node/core'
import { MedalOutlineIcon } from '@ikyucom/design-system-icons-react'
import { sva } from '~/styled-system/css'
import type { RestaurantAreaReviewRankingFragment } from '../restaurantAreaReviewRanking.frag'

type Props = {
  areaReviewRanking: ResultOf<typeof RestaurantAreaReviewRankingFragment>
  rating?: number
}

const styles = sva({
  slots: ['container', 'iconContainer', 'icon', 'rank', 'area'],
  base: {
    container: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'start',
      lineHeight: 'none',
    },
    iconContainer: {
      color: 'ranking',
    },
    rank: {
      fontWeight: 'bold',
      color: 'ranking',
      fontSize: 'md',
    },
    area: {
      fontSize: 'xs',
      fontWeight: 'bold',
      color: 'ranking',
      ml: '1',
      _pc: {
        fontSize: 'sm',
      },
    },
  },
})

function AreaReviewRanking({
  areaReviewRanking: {
    rank,
    total,
    minimumArea: {
      code: minimumAreaCode,
      name: minimumAreaName,
      parent: {
        code: smallAreaCode,
        parent: { key: mediumAreaKey },
      },
    },
  },
  rating,
}: Props) {
  // 順位が1～10位、かつ順位 <= 総店舗数/2、かつクチコミ点数が4.0以上の場合のみ表示
  const ranked = rank <= 10 && rank <= Math.floor(total / 2) && rating && rating >= 4.0
  const listUrl = `/area/${mediumAreaKey}/${smallAreaCode}/${minimumAreaCode}/ranking/rating/`
  const classes = styles()
  return ranked ? (
    <a href={listUrl} className={classes.container}>
      <div className={classes.iconContainer}>
        <MedalOutlineIcon width={16} height={16} />
      </div>
      <span className={classes.rank}>
        クチコミ{rank}位／{total}店舗
      </span>
      <span className={classes.area}> - {minimumAreaName}ランキング</span>
    </a>
  ) : null
}

export default AreaReviewRanking
